export const MANIFESTS_API_PATH = "manifest";
export const GET_LOT_SECTION_API_PATH = `${MANIFESTS_API_PATH}/check-last-lot?id={manifestId}`;

export const DOWNLOADS_API_PATH = "download";
export const MANIFEST_DOWNLOAD_API_PATH = `${DOWNLOADS_API_PATH}/download-manifest`;
export const MANIFEST_GROUP_DOWNLOAD_API_PATH = `${DOWNLOADS_API_PATH}/download-manifest-group`;
export const RECEIVING_DOWNLOAD_API_PATH = `${DOWNLOADS_API_PATH}/download-receiving`;
